<template>
  <History />
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import History from '@/components/content/History.vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'HistoryView',
  components: { History },
  setup(props, context) {
    const i18n = useI18n()
    context.emit('pageName', i18n.t('aside.menu.pages.history'))

    watch(() => i18n.locale.value, () => {
      context.emit('pageName', i18n.t('aside.menu.pages.history'))
    })
  }
})
</script>